module.exports = __webpack_public_path__ + "fonts/tetai-2.85902841.ttf";